export default {"id":"118e6e61","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}